var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15249_1269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1112 6.8758C12.9099 6.54856 12.6175 6.27879 12.2652 6.09535C11.9129 5.91191 11.514 5.82172 11.1112 5.83443H8.88897C8.2996 5.83443 7.73437 6.05386 7.31762 6.44445C6.90087 6.83504 6.66675 7.3648 6.66675 7.91718C6.66675 8.46955 6.90087 8.99931 7.31762 9.3899C7.73437 9.78049 8.2996 9.99992 8.88897 9.99992H11.1112C11.7006 9.99992 12.2658 10.2194 12.6825 10.6099C13.0993 11.0005 13.3334 11.5303 13.3334 12.0827C13.3334 12.635 13.0993 13.1648 12.6825 13.5554C12.2658 13.946 11.7006 14.1654 11.1112 14.1654H8.88897C8.48618 14.1781 8.08729 14.0879 7.73499 13.9045C7.38269 13.7211 7.09025 13.4513 6.88897 13.124",
    stroke: "#6A7181",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 14.4444V16.6666M10 3.33325V5.55547V3.33325Z",
    stroke: "#6A7181",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15249_1269"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarIcon);
export default __webpack_public_path__ + "static/media/dollar-icon.ecbbb422b655e329425c6bf2f041095e.svg";
export { ForwardRef as ReactComponent };